import { render, staticRenderFns } from "./DownloadList.vue?vue&type=template&id=06752103&scoped=true&"
import script from "./DownloadList.vue?vue&type=script&lang=js&"
export * from "./DownloadList.vue?vue&type=script&lang=js&"
import style0 from "./DownloadList.vue?vue&type=style&index=0&id=06752103&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06752103",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06752103')) {
      api.createRecord('06752103', component.options)
    } else {
      api.reload('06752103', component.options)
    }
    module.hot.accept("./DownloadList.vue?vue&type=template&id=06752103&scoped=true&", function () {
      api.rerender('06752103', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/user/DownloadList.vue"
export default component.exports